<template>
  <div>
    <div style="margin-bottom: 15px">
      <label>训练类型：</label>

      <el-cascader :options="categoryList" :props="{ checkStrictly: true }" clearable @change="handelCategoryList">
      </el-cascader>
    </div>
    <el-row :gutter="15" v-loading="loading">
      <el-col :span="8" v-for="(practice,index) in practiceList" :key="practice.id">
        <div class="grid-content" @click="courseHandler(practice.id)">
          <el-card :body-style="{ padding: '5px' }">
            <div class="wrapss">
              <img :src="GLOBAL.BASE_URL+practice.thum" class="image">
            </div>
            <div class="text clearfix courseInfo">
              <div class="infor">
                <p class="p1">{{practice.name}}</p>
                <p class="p2 p3"><span>{{practice.created_at}}</span><span class="pull-right"> <img src="../../../static/images/icon.svg" alt="">
                    {{ practice.user_count}}</span><span><img :src=GLOBAL.BASE_URL+practice.category.thum alt="" class="img"></span></p>
              </div>
              <div class="score">5.0分</div>
            </div>
          </el-card>
        </div>
      </el-col>
    </el-row>
    <div style="text-align: right" v-if="pageform.total>pageform.pageSize">
      <el-pagination background @current-change="pageCurrentChange" :page-count="pageform.pages" :current-page="pageform.pageNum" layout="prev, pager, next" :total="pageform.total" :page-size='9'>
      </el-pagination>
    </div>
  </div>
  <!--  <router-view>-->
  <!--  </router-view>-->
</template>
<script>
export default {
  name: 'PracticeList',
  data() {
    return {
      // 分页插件
      pageform: {
        total: 0,
        pages: 5,  // 总页数
        pageNum: 1, // 当前的页码
        pageSize: 9, // 每页显示条目个数
      },
      params: {
        class_id: this.$store.getters.getUserInfo.class_id,
        page_size: 9,
        page: 1
      },
      categoryList: [],
      value: '',
      practiceList: [],
      loading: true
    }
  },
  methods: {
    /* 分页插件 */
    // pageNum (当前页数)改变时会触发
    pageCurrentChange(val, e, form, jobExpLabel, pageform, searchVal) {
      // console.log('当前页:'+ val);
      this.pageform.pageNum = val;
      this.params.page = val;
      this.getCourseList();
    },
    // 获取分类列表
    getCategoryList() {
      this.$http.categoryTree()
        .then(res => {
          if (res.code !== 0) {
            var arr = []
            var obj = {}
            for (var i = 0; i < res.data.length; i++) {
              obj = {}
              obj.value = res.data[i].value
              obj.label = res.data[i].label
              if (res.data[i].children.length > 0) {
                obj.children = res.data[i].children
              }
              arr.push(obj)
            }
            this.categoryList = arr;

          } else {
            this.$message.error(res.message)
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    courseHandler(courseId) {
      console.log(courseId)
      this.$router.push({
        path: `/courses/${courseId}/details-introduce`,

      })
    },
    handelCategoryList(category_ids) {
      this.params.category_id = category_ids.slice(-1)[0];
      this.params.page = 1;
      this.pageform.pageNum = 1;

      this.getCourseList()
    },
    getCourseList() {
      this.$http.courseList(this.params)
        .then(res => {
          if (res.code !== 0) {
            this.practiceList = res.data.learn;
            this.pageform.pages = res.data.allPage;
            this.pageform.total = res.data.allCount;
            this.loading = false
          } else {
            this.$message.error(res.message)
          }

        })
    }
  },
  created() {
    this.getCourseList();
    this.getCategoryList();
  }
}
</script>
<style>
.el-row {
  margin-bottom: 20px;

  & :last-child {
    margin-bottom: 0;
  }
}
.p3 span {
  margin-right: 30px !important;
}
.el-col {
  border-radius: 4px;
}

.image {
  width: 100%;
  /* height: 140px; */
}

.bg-purple-dark {
  background: #99a9bf;
}
.wrapss {
  height: 150px;
  overflow: hidden;
}
.bg-purple {
  background: #d3dce6;
}

.bg-purple-light {
  background: #e5e9f2;
}

.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
</style>



// WEBPACK FOOTER //
// src/components/User/PracticeList.vue